import { TFunction } from "i18next";
import { ReturnType } from "src/hooks/use-boolean";

export const NOTIFICATIONS_TABS = (
  allCount: number,
  unreadCount: number,
  isUnReadOnly: ReturnType
) => [
  {
    value: "all" as "all",
    label: "All",
    count: allCount,
    onClick: isUnReadOnly.onFalse,
  },
  {
    value: "unread" as "unread",
    label: "Unread",
    count: unreadCount,
    onClick: isUnReadOnly.onTrue,
  },
];
